/**
 * Inside the laptop on the live mission, straight after the zoom through its
 * screen: what was opened (the mission page to view it again; the report
 * window to report in), with the countdown along the top.
 */
import { useEffect, useState, type ReactNode } from "react";
import { TopClock } from "./lid-clock";

/** How long the countdown takes to rise to the top (lid-clock smClockUp). */
const CLOCK_UP = 700;

export function LaptopDesktop({
  left,
  children,
}: {
  /** the mission window's time left */
  left: number;
  /** what the laptop opens into */
  children: ReactNode;
}) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setShown(true), CLOCK_UP);
    return () => window.clearTimeout(t);
  }, []);
  return (
    <div className="absolute inset-0 z-[30] overflow-hidden bg-black font-sans">
      {/* Built only once the clock has finished rising to the top
          (CLOCK_UP, its smClockUp), so the page's own entrances (the strike
          dropping in, the mission word by word) play from the start where
          they can be seen. `backwards`, not `both`: once in, it holds no
          transform or opacity — a style left on it by a finished animation
          stops iPhone Safari swipe-scrolling inside */}
      {shown ? (
        <div className="absolute inset-0 animate-[smScreenIn_.3s_ease-out_backwards]">
          {children}
        </div>
      ) : null}
      <TopClock left={left} />
      <style>{`@keyframes smScreenIn{from{opacity:0}to{opacity:1}}`}</style>
    </div>
  );
}
